import { Button } from "@mui/material";
import React from "react";
import { fonts, themes } from "../../themes/themes";

interface CustomAddButtonProps {
  btnLabel: string;
  disabled?: boolean;
  onClick?: any;
  width?: string;
  height?: string;
  icon?: any;
}

const CustomAddButton: React.FC<CustomAddButtonProps> = ({
  onClick,
  btnLabel,
  disabled = false,
  width,
  height,
  icon
}) => {
  return (
    <Button
      style={{
        width: width,
        height: height,
        backgroundColor: themes.primaryMain,

        color: "white",
        fontFamily: fonts.fontFamily,
        fontSize: fonts.title,
        boxShadow: "0px 3px 3px #00000061",
        borderRadius: "4px",
        paddingLeft: "1em",
        paddingRight: "1em",
        cursor: "pointer",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <span>
        <i className={icon ?? "las la-plus"} style={{ marginRight: "0.2em" }} />{" "}
      </span>{" "}
      {btnLabel}
    </Button>
  );
};
export default CustomAddButton;
